/* Vext — shared motion module
   Nine motion patterns from the motion direction spec. Idempotent. */
(function () {
  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var REVEAL_SEL = '.m-fade-up, .m-blur-in, .m-long-lift, .m-two-beat, .m-stagger > *';

  function applyReducedMotion() {
    document.querySelectorAll(REVEAL_SEL).forEach(function (el) {
      el.classList.add('play');
    });
  }

  function reveal(el) {
    if (el.classList.contains('m-stagger')) {
      var step = parseInt(el.getAttribute('data-stagger') || '80', 10);
      Array.prototype.forEach.call(el.children, function (c, i) {
        c.style.transitionDelay = (i * step) + 'ms';
        c.classList.add('play');
      });
    } else if (el.classList.contains('m-two-beat')) {
      el.classList.add('play');
      var italic = el.querySelector('.m-italic, .italic-grove');
      if (italic) {
        italic.style.transitionDelay = '380ms';
        italic.classList.add('m-italic', 'play');
      }
    } else {
      el.classList.add('play');
    }
  }

  // The observer's -10% bottom margin keeps anything in the lowest tenth of
  // the screen hidden until a scroll. That's right further down the page,
  // but on load it left text blank that was already in view, such as the
  // hero headline sitting just above the fold on phones. Anything on screen
  // at load plays straight away.
  function revealOnScreen() {
    if (!io) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('[data-m-observed="1"]').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top >= vh || rect.bottom <= 0) return;
      io.unobserve(el);
      el.dataset.mObserved = 'done';
      reveal(el);
    });
  }

  var io = null;
  function setupObserver() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.m-fade-up, .m-blur-in, .m-long-lift, .m-two-beat')
        .forEach(function (el) { el.classList.add('play'); });
      document.querySelectorAll('.m-stagger').forEach(function (el) {
        Array.prototype.forEach.call(el.children, function (c) { c.classList.add('play'); });
      });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          reveal(el);
          io.unobserve(el);
          el.dataset.mObserved = 'done';
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    }
    document.querySelectorAll('.m-fade-up, .m-blur-in, .m-two-beat, .m-stagger')
      .forEach(function (el) {
        if (el.classList.contains('play')) return;
        if (el.dataset.mObserved) return;
        el.dataset.mObserved = '1';
        io.observe(el);
      });
    revealOnScreen();
  }

  function playHero() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.querySelectorAll('.m-long-lift, .m-hero-blur').forEach(function (el) {
          el.classList.add('play');
        });
      });
    });
  }

  function autoTag(scope) {
    var root = scope || document;

    // Pattern 3 — Long lift on hero sections. Target the inner .container
    // so the section's bg color stays painted; only the content lifts.
    root.querySelectorAll('.sec--hero, section.pdp').forEach(function (el) {
      if (el.classList.contains('m-tagged-hero')) return;
      el.classList.add('m-tagged-hero');
      var inner = el.querySelector(':scope > .container, :scope > .final-cta') || el;
      inner.classList.add('m-long-lift');
    });

    // Two-beat italic — opt-in: any display heading containing .italic-grove.
    root.querySelectorAll('.display-1, .display-2, h1.h1, h2.h1, .hero-it__headline').forEach(function (h) {
      if (h.classList.contains('m-tagged-two-beat')) return;
      var italic = h.querySelector('.italic-grove');
      if (!italic) return;
      h.classList.add('m-two-beat', 'm-tagged-two-beat');
    });

    // Pattern 1 — Soft fade up on every non-hero inner section. Apply to the
    // .container child rather than the <section> so the bg color doesn't
    // fade in from the body cream — only the content fades.
    root.querySelectorAll('main section:not([class*="shopify-section"])').forEach(function (sec) {
      if (sec.classList.contains('m-tagged-hero')) return;
      if (sec.classList.contains('m-tagged-fade')) return;
      sec.classList.add('m-tagged-fade');
      var inner = sec.querySelector(':scope > .container, :scope > .final-cta') || sec;
      inner.classList.add('m-fade-up');
    });

    // Pattern 5 — Stagger on grid containers.
    var staggerSel = [
      '.three-up', '.three-up--scroll',
      '.incl-grid', '.pp-grid', '.pack-grid', '.real-grid',
      '.cmp-grid', '.cross-scroll', '.grow-row', '.feature-rows',
      '.testimonials', '.faq-list'
    ].join(',');
    root.querySelectorAll(staggerSel).forEach(function (el) {
      el.classList.add('m-stagger');
    });

    // Pattern 6 — Card lift on hover.
    var cardSel = [
      '.feat-card', '.incl-card', '.pp-card', '.pack-card',
      '.pl-feat-card', '.founder-card', '.zone-card',
      '.cycle-step', '.real-tile', '.testi-card', '.quote-card',
      '.pod-stat-card', '.cta-card', '.grow-card', '.variety-card',
      '.tier'
    ].join(',');
    root.querySelectorAll(cardSel).forEach(function (el) {
      el.classList.add('m-card-lift');
    });
  }

  // Wrap unwrapped "→" text in <span class="m-arrow"> so the transform
  // applies just to the arrow, not the whole link.
  function wrapArrows(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('a, button, .btn, .btn--text, .feat-card__link, .pl-feat-card__link, .footer ul a');
    nodes.forEach(function (node) {
      if (node.querySelector('.m-arrow')) return;
      Array.prototype.forEach.call(node.childNodes, function (c) {
        if (c.nodeType !== 3) return;
        var txt = c.nodeValue;
        if (txt.indexOf('→') === -1) return;
        var frag = document.createDocumentFragment();
        var parts = txt.split('→');
        parts.forEach(function (p, i) {
          if (p) frag.appendChild(document.createTextNode(p));
          if (i < parts.length - 1) {
            var span = document.createElement('span');
            span.className = 'm-arrow';
            span.textContent = '→';
            frag.appendChild(span);
          }
        });
        c.parentNode.replaceChild(frag, c);
      });
    });
  }

  // Scroll-driven fade for sticky elements: opacity tracks the parent
  // section's position so the element eases in as the section enters the
  // viewport and eases out as it leaves, instead of snapping at the
  // sticky boundaries. Triggered by [data-scroll-fade] on the element.
  function initScrollFade() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-fade]'));
    if (!els.length) return;
    // Hint the compositor so opacity changes don't repaint on the main thread.
    els.forEach(function (el) { el.style.willChange = 'opacity'; });
    function update() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var fadeZone = vh * 0.55; // wider zone — slower, more visible fade
      els.forEach(function (el) {
        var anchor = el.closest('section') || el.parentNode;
        if (!anchor) return;
        var rect = anchor.getBoundingClientRect();
        var entry = (vh - rect.top) / fadeZone;
        var exit = rect.bottom / fadeZone;
        var t = Math.max(0, Math.min(1, Math.min(entry, exit)));
        // Smoothstep — symmetric S-curve, gentle at both ends.
        var eased = t * t * (3 - 2 * t);
        el.style.opacity = eased;
      });
    }
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; update(); });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }

  // Sticky behavior with eased boundary transitions. Uses position:
  // relative + a JS-computed translate so we can smooth the velocity
  // change at the entry/exit boundaries (where pure position: sticky
  // would snap from "moving with scroll" to "stationary").
  // Outside the smoothing window the translate matches exactly what
  // sticky would do, so steady-state scroll feel is unchanged.
  function initSmoothSticky() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-sticky]'));
    if (!els.length) return;
    var STICKY_TOP = 96;
    var W = 80; // px smoothing window at each boundary

    // Cubic ramp that's 0 at x ≤ -W, x at x ≥ W, and smooth (C¹) in between.
    // Derived to match boundary values + slopes (0 and 1) — that's why the
    // velocity transitions cleanly instead of snapping.
    function ramp(x) {
      if (x >= W) return x;
      if (x <= -W) return 0;
      return x * x / (4 * W) + x / 2 + W / 4;
    }

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
    }

    function update() {
      var mobile = isMobile();
      els.forEach(function (el) {
        if (mobile) { el.style.transform = ''; return; }
        var section = el.closest('section');
        if (!section) return;
        var rect = section.getBoundingClientRect();
        var h = el.offsetHeight;
        // entry "stickiness" — positive once the section top crosses the sticky line
        var xEntry = STICKY_TOP - rect.top;
        // exit "release" — positive once the section bottom passes (sticky line + image height)
        var xExit = (STICKY_TOP + h) - rect.bottom;
        var translate = ramp(xEntry) - ramp(xExit);
        el.style.transform = 'translate3d(0, ' + translate + 'px, 0)';
      });
    }
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; update(); });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }

  function init(scope) {
    if (reduced) {
      autoTag(scope);
      applyReducedMotion();
      wrapArrows(scope);
      return;
    }
    autoTag(scope);
    setupObserver();
    playHero();
    wrapArrows(scope);
    initScrollFade();
    initSmoothSticky();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () { init(); });
  // Fonts and images can still shift the layout after DOMContentLoaded.
  window.addEventListener('load', revealOnScreen);

  // ---- Pattern 8: AnimateNumber-style price ticker ----
  // Interpolates between the element's current numeric value and the target
  // value, formatting each frame in the target's locale (€849 vs €1.149 etc.).
  function parsePrice(str) {
    var clean = String(str).replace(/<[^>]+>/g, '').trim();
    var m = clean.match(/^(\D*)([\d.,]+)(\D*)$/);
    if (!m) return null;
    var prefix = m[1], digits = m[2], suffix = m[3];
    var hasComma = digits.indexOf(',') > -1;
    var hasDot = digits.indexOf('.') > -1;
    var decimalSep = '', thousandSep = '';
    if (hasComma && hasDot) {
      if (digits.lastIndexOf(',') > digits.lastIndexOf('.')) {
        decimalSep = ','; thousandSep = '.';
      } else {
        decimalSep = '.'; thousandSep = ',';
      }
    } else if (hasComma) {
      var afterComma = digits.split(',').pop();
      if (afterComma.length === 2) decimalSep = ','; else thousandSep = ',';
    } else if (hasDot) {
      var afterDot = digits.split('.').pop();
      if (afterDot.length === 2) decimalSep = '.'; else thousandSep = '.';
    }
    var num;
    if (decimalSep) {
      var parts = digits.split(decimalSep);
      var intPart = parts[0].replace(/[^\d]/g, '');
      num = parseFloat(intPart + '.' + (parts[1] || '0'));
    } else {
      num = parseFloat(digits.replace(/[^\d]/g, ''));
    }
    return {
      prefix: prefix,
      suffix: suffix,
      thousandSep: thousandSep,
      decimalSep: decimalSep,
      decimals: decimalSep ? (digits.split(decimalSep).pop().length) : 0,
      value: num
    };
  }

  function formatPrice(fmt, value) {
    var intPart = Math.floor(value);
    var intStr = String(intPart);
    if (fmt.thousandSep) {
      intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thousandSep);
    }
    var out = intStr;
    if (fmt.decimals > 0) {
      var frac = (value - intPart).toFixed(fmt.decimals).slice(2);
      out += fmt.decimalSep + frac;
    }
    return fmt.prefix + out + fmt.suffix;
  }

  // Update the deepest text node so we don't fight a wrapper added by
  // a currency-switcher app (e.g. Transcy).
  function getInnermostTextNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var c = el.childNodes[i];
      if (c.nodeType === 3) return c;
      if (c.nodeType === 1) {
        var inner = getInnermostTextNode(c);
        if (inner) return inner;
      }
    }
    var n = document.createTextNode('');
    el.appendChild(n);
    return n;
  }

  function easeOutQuart(t) { var u = 1 - t; return 1 - u * u * u * u; }

  function animatePrice(el, toStr, opts) {
    if (!el) return;
    if (toStr == null) return;
    var toFmt = parsePrice(toStr);
    if (!toFmt) { el.innerHTML = toStr; return; }
    var fromFmt = parsePrice(el.textContent);
    if (reduced || !fromFmt || fromFmt.value === toFmt.value) {
      el.innerHTML = toStr;
      return;
    }
    if (el.__priceRAF) cancelAnimationFrame(el.__priceRAF);
    var duration = (opts && opts.duration) || 360;
    var from = fromFmt.value;
    var to = toFmt.value;
    var start = performance.now();
    // Cents are held at their final value for the whole flight rather than
    // being animated, so they don't dance. They used to be dropped entirely
    // mid-flight, which was invisible while prices rendered as whole numbers
    // but now reads as the decimals vanishing and the number changing width,
    // since every price carries them.
    var heldFrac = to - Math.floor(to);
    // The target may carry no thousands separator while values passed through
    // on the way do: counting down from €1.098,00 to €849,00 has nothing to
    // copy the grouping from, so it used to drop out and render €1098 in
    // flight. Borrow it from the origin in that case.
    var flightFmt = toFmt.thousandSep ? toFmt : {
      prefix: toFmt.prefix,
      suffix: toFmt.suffix,
      thousandSep: fromFmt.thousandSep,
      decimalSep: toFmt.decimalSep,
      decimals: toFmt.decimals
    };
    var lastRendered = null;
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var current = from + (to - from) * easeOutQuart(t);
      // Only the integer part moves, so this still only changes — and so only
      // touches the DOM — when that part does.
      var rendered = formatPrice(flightFmt, Math.floor(current) + heldFrac);
      if (rendered !== lastRendered) {
        getInnermostTextNode(el).nodeValue = rendered;
        lastRendered = rendered;
      }
      if (t < 1) {
        el.__priceRAF = requestAnimationFrame(tick);
      } else {
        // Settle: re-set innerHTML to the canonical string so any wrapper
        // markup (Transcy span, etc.) in toStr is restored.
        el.innerHTML = toStr;
        el.__priceRAF = null;
      }
    }
    el.__priceRAF = requestAnimationFrame(tick);
  }

  // Shopify theme editor: re-tag when a section is re-rendered/added.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:reorder', function () { init(); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });

  // Public API for after dynamic content updates (e.g. cart drawer)
  // and for the price ticker called from main.js handlers.
  window.__vextMotion = {
    rescan: function (scope) { init(scope); },
    animatePrice: animatePrice
  };
})();
